import { useMemo } from 'react'

import { usePaginationQuery } from '@app/hooks/usePaginationQuery'

import { getPaginationParams } from '@app/utils'

import type { PaginationParamsHookReturn } from '@app/types/pagination'

export const usePaginationQueryParams = (): PaginationParamsHookReturn => {
  const { pagination, setPagination, resetCurrentPage } = usePaginationQuery()

  const paginationParams = useMemo(() => getPaginationParams(pagination), [pagination])

  return {
    paginationParams,
    pagination,
    setPagination,
    resetCurrentPage
  }
}
